<section>
     @if(loaded && items && columns && tableConfigurations) {
     <i-title [text]="title" level="1" [buttons]="titleButton()"></i-title>
     <div>
          <div class="d-flex flex-row align-content-center gap-4 mb-1 mt-3">
               <input pInputText [(ngModel)]="pointsIdSearch" (ngModelChange)="onSearchPointId()"
                    [disabled]="withFilters" [placeholder]="'Rechercher par ID...'">
               <span>
                    <idel-table-columns-filter [columns]="columnsFilters"
                         [sessionStorageKey]="'points-list-table-column-filters'"
                         (onFilter)="onFilterPointsCurrentTablePage($event)"
                         (onReset)="onFilterReset()"></idel-table-columns-filter>
               </span>
          </div>

          <i-table-v17 #superTable [loading]="loadingTable()" height="85vh" [id]="'idTableauDeBordPoints'"
               [items]="withSearch || withFilters ? itemsCopy: items" [columns]="columns" [config]="tableConfigurations"
               [menu]="menu" [customActions]="forselection" [customActionManualReset]="true"
               (pageChange)="pageChange($event)" (onSelectedRow)="showDetails($event)"
               (onMenuRowClick)="receive_menu($event)" (onColumnSort)="columnSort($event)">
          </i-table-v17>
          <!-- <idel-basic-table [loading]="loadingTable()" [items]="withSearch || withFilters ? itemsCopy: items"
               [clickableRow]="true" [checkableRows]="true" [columns]="columns" [height]="'85vh'"
               [exportable]="true"></idel-basic-table> -->

     </div>
     }@else {
     <div class="w-100 justify-content-center align-items-center d-flex" style="height: 100dvh;">
          <span>
               <i-loader></i-loader>
          </span>
     </div>
     }
</section>


<p-dialog #formDialogDuplicatePoint styleClass="super-compos-modal-content" [(visible)]="openDuplicationManagementModal"
     [modal]="true" [style]="{width: '30vw'}" appendTo="body" [closable]="false">
     <p-header>
          <div class="d-flex align-items-center justify-content-between">
               <h5 class="modal-title super-compos-modal-title">
                    {{'duplicate.duplicationManagement'|translate}}
               </h5>
               <div class="d-flex">
                    <super-button styleClass="blue" (click)="openDuplicationManagementModal = false"
                         [text]="'btn.cancel'|translate"></super-button>
                    <super-button styleClass="green ms-3" (click)="submitDuplicationManagement()"
                         text="Confirmer"></super-button>
               </div>
          </div>
     </p-header>
     <section [formGroup]="formDuplicationPoint">
          <div class="row" *ngIf="duplicationManagementIndex ===0">
               <!-- 1st part of the modal directly accessed when its opened -->
               <div class="col-12 mb-2">
                    <p-checkbox [label]="'duplicate.pointContent'|translate" binary="true"
                         formControlName="infos"></p-checkbox>
               </div>
               <div class="col-12 mb-2" *ngIf="files.length >0">
                    <p-checkbox [label]="'duplicate.filesSelection'|translate" binary="true"
                         formControlName="files"></p-checkbox>
               </div>
               <div class="col-12">
                    <p-checkbox [label]="'duplicate.recipients'|translate" binary="true"
                         formControlName="recipients"></p-checkbox>
               </div>
          </div>
          <div class="row" *ngIf="duplicationManagementIndex ===1">
               <!-- 2nd part of the modal accessed when the user chose to add files to the duplication-->
               <div class="col-12">
                    <super-table [initialSelection]="filesForDuplication" [forselectionDefaultOption]="false"
                         #superTableFilesDuplication [forselection]="null"
                         [items]="filesForDuplication|sort:'OrdreAffichage':'ASC'" [columns]="columnsFiles"
                         id="super-files-tables-Duplication" [height]="'calc( 100vh - 400px)'" [multiselect]="true">
                    </super-table>
               </div>
          </div>
     </section>
</p-dialog>
<p-confirmDialog key="modalTable" #cd appendTo="body" styleClass="super-compos-modal-content confirmModal"
     header="Confirmation" icon="pi pi-exclamation-triangle">
     <p-footer>
          <button type="button" pButton icon="pi pi-times" label="Non" (click)="cd.reject()"></button>
          <button class="pButtonRed" type="button" pButton icon="pi pi-check" label="Oui"
               (click)="cd.accept()"></button>
     </p-footer>
</p-confirmDialog>